import React from "react";
import close from "../../../assets/images/model/close.svg";
import { useNavigate } from "react-router-dom";

const SupportModel = ({ setTroubleModel, setThanksModel, setSupportModel }) => {
  const navigate = useNavigate();
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="confirm_authors"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="confirm_authorsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src={close}
                alt="close"
                onClick={() => {
                  setSupportModel(false);
                  setTroubleModel(false);
                  setThanksModel(false);
                }}
              />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>thanks for contacting greyled support</h4>
            <p>
              We will reach out to you as soon as we can to help you with your
              book upload. While you wait, explore greyled
              <span className="create-colo">create</span> with the Greyled 101
              book and activity.
            </p>
            <form action="" className="confirm_authors">
              <div className="confirm_authors my-40"></div>
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={() => {
                    navigate("/create/uploadbook");
                  }}
                >
                  Done
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    // setSelectChapter(true);
                    setSupportModel(false);
                    setTroubleModel(true);
                  }}
                >
                  Go to greyled<span className="tech-color">teach</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportModel;
